export default __webpack_public_path__ + "static/media/exterior (2).fff977dc.jpg";